export default __webpack_public_path__ + "static/media/thedaintyheart.e83fbf34.jpeg";